/* eslint-disable camelcase */
const {
    Link_previous,
    Link_next,
    Search_no_results,
    Search_one_character_or_more,
    Search_one_result,
    Search_results,
    Search_should_be_x_or_more,
    Search_too_short
} = window.searchTranslation;

const textLinkPrevious = Link_previous;
const textLinkNext = Link_next;
const textSearchNoResults = Search_no_results;
const textSearchOneCharacterOrMore = Search_one_character_or_more;
const textSearchOneResult = Search_one_result;
const textSearchResults = Search_results;
const textSearchShouldBeXOrMore = Search_should_be_x_or_more;
const textSearchTooShort = Search_too_short;
/* eslint-enable camelcase */

export {
    textLinkPrevious,
    textLinkNext,
    textSearchNoResults,
    textSearchOneCharacterOrMore,
    textSearchOneResult,
    textSearchResults,
    textSearchShouldBeXOrMore,
    textSearchTooShort
};
